// extracted by mini-css-extract-plugin
export default {"location-section":"location_location-section__Xe8bm","subheader":"location_subheader__Z22CZ","articles":"location_articles__C5iJZ"};